// extracted by mini-css-extract-plugin
export var content = "Banner-module--content--07f4d";
export var hideSubtitleOnMobile = "Banner-module--hideSubtitleOnMobile--be27b";
export var root = "Banner-module--root--d0b7f";
export var subtitle = "Banner-module--subtitle--48de9";